module.exports = __webpack_public_path__ + "img/quarterfold.22921bd6.jpg";